import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setHoverElement } from '../../../redux/hoverElementSlice';
import EditorTitleInput from '../../editorInputs/EditorTitleInput';
import PropEditorArrayItem from './PropEditorArrayItem';
import PropEditorElement from './PropEditorElement';
import { UilAngleDown, UilAngleUp } from '@iconscout/react-unicons';

const PropsEditorRow = ({ componentName, componentId, idx, props, title, toggleOpen, isOpen }) => {
	const [elementHeight, setElementHeight] = React.useState('0px');
	const elementRef = React.useRef(null);
	const dispatch = useDispatch();

	React.useState(() => {
		let h = 'auto';
		if (!isOpen) {
			h = `${elementRef?.current?.scrollHeight}px`;
		}
		setElementHeight(h);
	}, [isOpen]);

	const handleMouseEnter = (componentId, componentName) => {
		dispatch(setHoverElement({ componentId, componentName, isCanvas: true }));
	};

	const handleMouseLeave = (componentId) => {
		dispatch(setHoverElement({ componentId: null, componentName: null }));
	};
	return (
		<Flex
			width={'100%'}
			border={'1px solid #E2E8F0'}
			borderRadius={'10px'}
			flexWrap={'wrap'}
			onMouseEnter={() => handleMouseEnter(componentId, componentName)}
			onMouseLeave={() => handleMouseLeave(componentId)}
		>
			<Text
				display={'flex'}
				justifyContent={'space-between'}
				_hover={{ cursor: 'pointer' }}
				onClick={toggleOpen}
				m={0}
				p={1}
				fontSize={'md'}
				fontWeight={'bold'}
				w={'100%'}
			>
				{componentName}
				{props?.blockClass ? `#${props.blockClass}` : ''}
				{isOpen ? <UilAngleUp size={24} /> : <UilAngleDown size={24} />}
			</Text>

			<Box ref={elementRef} h={elementHeight} overflow={'hidden'} w={'100%'}>
				{isOpen ? (
					<Box display={'flex'} flexWrap={'wrap'}>
						{<EditorTitleInput {...{ componentId, titleValue: title }} />}
						{Object.keys(props || {}).map((propName, index) => {
							if (Array.isArray(props[propName])) {
								return (
									<Box w={'100%'}>
										{props[propName].map((prop, arrayIndex) => (
											<PropEditorArrayItem
												{...{
													originalPropname: propName,
													componentName,
													componentName,
													prop,
													props,
													componentId,
													componentName,
													arrayIndex,
												}}
												key={componentId + '-' + propName + '-' + index + '-' + arrayIndex}
											/>
										))}
									</Box>
								);
							} else {
								return (
									<PropEditorElement
										key={componentId + '-' + propName + '-' + index}
										{...{ propName, componentName, props, componentId, componentName }}
									/>
								);
							}
						})}
					</Box>
				) : null}
			</Box>
		</Flex>
	);
};

export default PropsEditorRow;
